import { create } from 'zustand';

interface SaveFileDialogState {
    visible: boolean;
    fileKey?: string;
    
    // Actions
    show: (fileKey: string) => void;
    hide: () => void;
}

const useSaveFileDialogStore = create<SaveFileDialogState>((set) => ({
    visible: false,
    fileKey: undefined,
    
    show: (fileKey: string) => set({ 
        visible: true, 
        fileKey 
    }),
    
    hide: () => set({ 
        visible: false, 
        fileKey: undefined 
    })
}));

export default useSaveFileDialogStore;

// 导出便捷的服务函数
export const saveFileDialogService = {
    show: (fileKey: string) => useSaveFileDialogStore.getState().show(fileKey),
    hide: () => useSaveFileDialogStore.getState().hide(),
    isVisible: () => useSaveFileDialogStore.getState().visible,
    getCurrentFileKey: () => useSaveFileDialogStore.getState().fileKey
};
